<mat-label class="subHeading">Premium Payment Type<span *ngIf="isRequired" class="star">*</span></mat-label>
<mat-select class="premium" [placeholder]="!isMultiSelect ? 'Select' : 'All'" formControlName="premium_payment_type" multiple>
    <mat-option (onSelectionChange)="selectionChange($event)" value="single">Single</mat-option>
    <mat-option (onSelectionChange)="selectionChange($event)" value="limited">Limited</mat-option>
    <mat-option (onSelectionChange)="selectionChange($event)" value="regular">Regular</mat-option>
</mat-select>